import { IconButton, Close16, Spinner } from '@cian/ui-kit';
import * as React from 'react';

import { IAgentSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import * as styles from './ChatPopup.css';
import { IOffer } from '../../types/offerData';
import { getAgentName } from '../../utils/agent';
import { createAgentIdName } from '../../utils/createAgentIdName';

interface IChatPopupProps {
  offer: IOffer;
  agent: IAgentSchema | null;
  gaLabel?: string;
  gaProducts?: string;
  onClose(): void;
}

export const ChatPopup: React.VFC<IChatPopupProps> = ({ agent, offer, onClose, gaProducts, gaLabel }) => {
  const { id, dealType, offerType, cianUserId } = offer;

  const [isLoading, setIsLoading] = React.useState(true);

  const onLoad = () => setIsLoading(false);

  /* istanbul ignore next */
  const companionName = agent && (getAgentName(agent, offer) || createAgentIdName(agent));

  /* istanbul ignore next */
  const src =
    `/dialogs/?hostType=frame&offerId=${id}` +
    `&dealType=${dealType}&offerType=${offerType}` +
    `${companionName ? '&companionName=' + encodeURIComponent(companionName) : ''}` +
    `${cianUserId ? '&companionId=' + encodeURIComponent(cianUserId) : ''}` +
    `${gaProducts ? '&gaProducts=' + encodeURIComponent(gaProducts) : ''}` +
    `${gaLabel ? '&gaLabel=' + encodeURIComponent(gaLabel) : ''}` +
    '&pageType=Card';

  return (
    <div className={styles['container']}>
      <span className={styles['close']}>
        <IconButton icon={<Close16 />} onClick={onClose} />
      </span>
      {isLoading && (
        <span className={styles['spinner']} data-testid="spinner">
          <Spinner size={16} />
        </span>
      )}
      <iframe className={styles['iframe']} src={src} onLoad={onLoad} onError={onLoad} />
    </div>
  );
};
